import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { SnowplowSchemaName } from '../../schemas';
import type { EventDefinition } from '../../types';

export const deal_tip_flag: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, ['target', 'issue', 'additional_feedback']),
  }),
  addContexts: ({ eventData } = {}) => {
    const contextNames: SnowplowSchemaName[] = ['deal_tip'];

    if (eventData?.org_unit) {
      contextNames.push('org_unit');
    }

    if (eventData?.call) {
      contextNames.push('call');
    }

    return createContexts(contextNames, { eventData });
  },
};
